<template>
  <div>
    <LoadingContainer v-if="loading"/>

    <div v-else>
      <FormLayout
          :initial="contentEvent.attributes"
          :errors="errors"
          :company-id="contentEvent.attributes.company_id"
          :content-event-categories="contentEventCategories"
          :portal="portal"
          :url="portal.attributes.base_url + '/' + contentEvent.attributes.path"
          :edit="true"
          @submit="submit"
          @copy="copy"
      />

      <CopyModal :content-event="contentEvent"/>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import FormLayout from '../../../../../../../components/Administration/ContentEvents/Layouts/Form'
import LoadingContainer from '../../../../../../../components/Layout/LoadingContainer'
import CopyModal from "../../../../../../../components/Modals/Administration/Content/ContentEvents/Copy.vue";

export default {
  components: {CopyModal, LoadingContainer, FormLayout},

  props: {
    portal: {
      required: true
    },

    blockDrivers: {
      required: true
    },

    layoutCategories: {
      required: true
    }
  },

  data() {
    return {
      contentEvent: null,
      contentEventCategories: null,
      loading: true,

      errors: {}
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      Promise.all([
        http.get('/api/v2/content-events/' + this.$route.params.contentEventId),
        http.get('/api/v2/content-event-categories', {'filter[portal_id]': this.portal.id, page_size: 100})
      ]).then(responses => {
        this.contentEvent = responses[0].data.data

        this.contentEventCategories = responses[1].data.data

        this.loading = false
      })
    },

    submit(data) {
      http.put('/api/v2/content-events/' + this.$route.params.contentEventId, data)
          .then(response => {
            notify.success('The content event was saved')

            this.contentEvent = response.data.data

            this.errors = {}
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }

            throw error
          })
    },

    copy() {
      $('#copy-content-event-modal').modal('show')
    }
  }
}
</script>
